<template>
  <div class="wrapper">
    <HeaderBar v-if="userDetails !== null"
               :locations="userDetails.locations" />
    <SideBar v-if="userDetails !== null" />
    <div class="content-wrapper px-0" style="height: 100% !important;min-height: 100% !important">
      <!--Main content-->
      <div class="content px-0">
        <!--every component must be have parent div container-fluid-->
        <div class="container-fluid mt-1">
          <b-card body-class="p-1" style="min-height: 650px;">
            <bread-crumb v-show="showBreadCrumb" />
            <slot v-if="!ajaxing" />
          </b-card>
        </div>
      </div>
      <!--/.content-->
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';

  //import components
  import HeaderBar from "./../views/Header";
  import SideBar from "../components/SideBar.vue";
  import BreadCrumb from '../components/BreadCrumb.vue';

  export default {
    components: {
      HeaderBar,
      SideBar,
      BreadCrumb
    },
    data() {
      return {
        ajaxing: true,
      };
    },
    methods: {
      showNoPropertySelected: function () {
        let message = {
          title: "Reminder",
          body: "Please select property.",
        };
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: "Ok",
          type: "basic", // coming soon: 'soft', 'hard'
        };

        this.$dialog.alert(message, options);
      }
    },
    watch: {
      ActiveLocation: function (val, old) {
        if (val === null) {
          this.showNoPropertySelected();
          return;
        }

        if (old !== null && val.pvid !== old.pvid || this.ajaxing) {
          this.ajaxing = true;
          this.$store.dispatch('GetReservationConfig').finally(() => {
            this.ajaxing = false;
          });
        }

      },
    },
    computed: {
 
      ...mapGetters({
        'ActiveLocation': 'GetActiveLocation'
      }),
      ...mapState({
        userDetails: state => state.UserDetails
      }),
      showBreadCrumb: function () {

        const hasShowBreadCrumb = 'showBreadCrumb' in (this.$route.meta || {})

        if (hasShowBreadCrumb) {
          return this.$route.meta.showBreadCrumb;
        } else {

          return true;

        }


      }
    },
  };
</script>



// WEBPACK FOOTER //
// src/layouts/Main.vue